import { useEffect, useState } from "react";
import { Download, Smartphone, X } from "lucide-react";
import { toast } from "sonner";

function isIOS() {
  const ua = navigator.userAgent || "";
  return /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
}

function isStandalone() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

export default function InstallPWA({ variant = "button" }) {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [supported, setSupported] = useState(false);
  const [showIOS, setShowIOS] = useState(false);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    if (isStandalone()) { setInstalled(true); return; }
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setSupported(true);
    };
    const onInstalled = () => { setInstalled(true); setDeferredPrompt(null); };
    window.addEventListener("beforeinstallprompt", handler);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const install = async () => {
    if (isIOS() && !isStandalone()) { setShowIOS(true); return; }
    if (!deferredPrompt) {
      // Fallback: show manual instructions
      toast.info("No teu navegador, abre o menu (⋮) → Instalar app / Adicionar à tela inicial");
      return;
    }
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") toast.success("Atalho criado! Abre pela tela inicial.");
    setDeferredPrompt(null);
  };

  if (installed) return null;

  const btn = (
    <button
      data-testid="install-pwa-btn"
      onClick={install}
      className={variant === "hero"
        ? "brutal-btn"
        : "flex items-center gap-2 px-3 py-2 border-2 border-[#CCFF00] text-[#CCFF00] font-bebas text-sm tracking-wider hover:bg-[#CCFF00] hover:text-black transition-colors"
      }
      title="Instalar como app no seu dispositivo"
    >
      <Download size={variant === "hero" ? 20 : 16}/>
      Atalho inicial
    </button>
  );

  return (
    <>
      {btn}
      {showIOS && (
        <div data-testid="ios-install-modal" className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-end md:items-center justify-center p-4" onClick={()=>setShowIOS(false)}>
          <div onClick={(e)=>e.stopPropagation()} className="brutal-card brutal-shadow max-w-md w-full" style={{borderColor:'#CCFF00'}}>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Smartphone className="text-[#CCFF00]" size={28}/>
                <span className="sticker">INSTALAR NO IPHONE</span>
              </div>
              <button data-testid="ios-close" onClick={()=>setShowIOS(false)} className="text-white/60 hover:text-white"><X size={22}/></button>
            </div>
            <h3 className="mt-4 font-bebas text-3xl tracking-tighter">Adicionar à tela inicial</h3>
            <ol className="mt-6 space-y-3 font-manrope text-white/80">
              <li className="flex gap-3"><span className="font-bebas text-[#CCFF00] text-2xl">1.</span>Toca no botão <b>Compartilhar</b> (quadrado com seta pra cima) no Safari</li>
              <li className="flex gap-3"><span className="font-bebas text-[#CCFF00] text-2xl">2.</span>Rola pra baixo e toca em <b>"Adicionar à Tela de Início"</b></li>
              <li className="flex gap-3"><span className="font-bebas text-[#CCFF00] text-2xl">3.</span>Toca em <b>Adicionar</b>. Pronto, o CRIA vai virar app!</li>
            </ol>
            <div className="mt-6 text-xs text-white/50 font-manrope">
              * Só funciona no Safari. Se estiver em outro navegador, abre no Safari primeiro.
            </div>
          </div>
        </div>
      )}
    </>
  );
}
